'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrivacyFooter = function PrivacyFooter(props) {
  var className = props.className,
      privacyUrl = props.privacyUrl,
      privacyStatement = props.privacyStatement,
      termsOfUseUrl = props.termsOfUseUrl;


  return _react2.default.createElement(
    'footer',
    { className: 'pxl-privacy-footer ' + className },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'p',
            { className: 'pxl-footer-privacy-statement' },
            _react2.default.createElement('span', { className: 'icon-lock' }),
            '\xA0',
            privacyStatement
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'a',
            { href: termsOfUseUrl },
            'Terms of Use'
          ),
          _react2.default.createElement(
            'span',
            null,
            '\xA0|\xA0'
          ),
          _react2.default.createElement(
            'a',
            { href: privacyUrl },
            'Privacy Policy'
          )
        )
      )
    )
  );
};

PrivacyFooter.propTypes = {
  className: _propTypes2.default.string,
  privacyStatement: _propTypes2.default.string.isRequired,
  privacyUrl: _propTypes2.default.string.isRequired,
  termsOfUseUrl: _propTypes2.default.string.isRequired
};

PrivacyFooter.defaultProps = {
  className: ''
};

exports.default = PrivacyFooter;